/**
 * tabs 页面主页
 */
function tabsPageInit(){
  //console.log('--tabs-page start--')
  //console.log('00000')
  var ELEMENT_CONTENT = '.tabs-main-page .card-body .tab-content';
  var ELEMENT_CONTENT_IFRAME= ELEMENT_CONTENT + ' .tab-pane iframe'
  //console.log('ELEMENT_CONTENT:',$(ELEMENT_CONTENT).length, $('.tabs-page').length)
  if($(ELEMENT_CONTENT).length>0){
    //console.log('dgdfgd')
    var ELEMENT_CONTENT_ITEM = ELEMENT_CONTENT + ' .tab-pane'
    var topDistance = $(ELEMENT_CONTENT).offset().top;
    var cusOffset = 16 + 15;
    //console.log('topDistance:', topDistance)
    var tableHeight = window.innerHeight - topDistance - cusOffset
    $(ELEMENT_CONTENT_ITEM).css('height', tableHeight + 'px');
    $(ELEMENT_CONTENT_IFRAME).css('height', tableHeight + 'px')
    //console.log('窗口宽：' + window.innerWidth, '窗口高：' + window.innerHeight, '设置高:' + tableHeight)
  }
  //console.log('--tabs-page end--')
}
export default tabsPageInit
